import { Device, OverviewDevice } from './device.model';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class DeviceUtils {
  public static isOnline(device: { state?: { online: boolean }; active?: boolean; lastActiveNanoSeconds?: number }): boolean {
    //Asset Hub
    if (device.active !== undefined) {
      return device.active;
    }

    //Device Service
    if (device.state) {
      return device.state.online;
    }

    //legacy
    if (!device.lastActiveNanoSeconds) {
      return false;
    }

    const lastActiveSeconds = device.lastActiveNanoSeconds / 1_000_000_000;
    const currentTime = Date.now() / 1_000;

    // 30 min no data --> offline
    return lastActiveSeconds >= currentTime - 1_800;
  }

  public static isMonitored(device: Device | OverviewDevice): boolean {
    //1. Device Service / 2. Asset Hub
    return device.configuration?.['FEATURES']?.includes('MONITORING') || device.configuration?.MONITORING === 'true';
  }

  public static isInProvisioning(device: Device | OverviewDevice): boolean {
    return !!device?.configuration?.['in_provisioning']?.includes('true');
  }
}
